import React, { useEffect, useState } from "react";
import { uppercase, numberWithSpaces } from "../services/utils/format";
import { useRegistrationContext } from "../contexts/registrationContext";
import { strings } from "../assets/resources/translations";
import { getUniqueObjects } from "../services/utils/array";
import Select from "../elements/Select";
import Radio from "../elements/Radio";
import moment from "moment";
import { useForm } from "../hooks/useForm";

// TODO: remane basic

const setBasePrice = (
  nrOfPax,
  priceConfig,
  addSpecification,
  removeSpecification
) => {
  const { basePrice, singleOccupancyFee } = priceConfig;
  removeSpecification({ type: "basic" }, true);
  addSpecification({
    name: "basePrice",
    type: "basic",
    quantity: parseInt(nrOfPax),
    price: parseInt(basePrice),
  });

  if (nrOfPax === "1" && singleOccupancyFee) {
    addSpecification({
      name: "singleOccupancyFee",
      type: "basic",
      price: parseInt(singleOccupancyFee),
    });
  }
};

const getPaxOptions = (pricing) => {
  return [
    {
      name: `1 ${strings.person}`,
      value: "1",
      price: pricing.singleOccupancyFee ? pricing.singleOccupancyFee : 0,
      information:
        pricing.singleOccupancyFee && pricing.singleOccupancyFee > 0
          ? { text: "singleFeeInformation", title: "singleFee" }
          : null,
    },
    { name: `2 ${strings.personsInSameRoom}`, value: "2" },
  ];
};

const getAirportsOptions = (departures) => {
  if (!departures) {
    return [];
  }
  let temp = departures.map((item) => item["airport"]);
  temp = getUniqueObjects(temp);
  temp = temp.map((item) => {
    return { ...item, name: strings[item.name] };
  });
  return temp;
};

// TODO: Sort dates in order
const getDateOptions = (departures, airport) => {
  if (!airport || !departures) {
    return [];
  }
  let temp = departures
    .filter((item) => item.airport.key === airport)
    .map((item) => {
      const outbound = moment(new Date(item.outbound));
      const homebound = moment(new Date(item.homebound));
      return {
        // TODO: translate months
        name: `${outbound.format("DD")} ${
          strings[outbound.format("MMM").toLowerCase()]
        } - ${homebound.format("DD")} ${
          strings[homebound.format("MMM").toLowerCase()]
        }, ${numberWithSpaces(item.pricing.basePrice)}:- ${item.tag || ""}`,
        key: item.id,
      };
    });

  return temp;
};
const getDepartureData = (departures, id) => {
  return departures.find((item) => String(item.id) === String(id));
};

const init = {
  inputs: {
    departureAirport: undefined,
    outbound: undefined,
    homebound: undefined,
    departureId: undefined,
    nrOfPax: undefined,
    pricing: undefined,
    tag: undefined,
  },
  rules: {
    departureAirport: ["required"],
    outbound: ["required"],
    homebound: ["required"],
    departureId: ["required"],
    nrOfPax: ["required"],
  },
};


const Basic = ({ name, displayErrors }) => {
  const form = useForm(init);
  const { inputs, errors, setInit, isValid, updateMultiple, handleChange } =
    form;

  const {
    config: { departures },
    price: { addSpecification, removeSpecification, setPriceSettings },
    wrapper: { updateInput, updateValidity },
  } = useRegistrationContext();

  /* Local option variables for select */
  const [airportOptions, setAirportOptions] = useState([]);
  const [dateOptions, setDateOptions] = useState([]);
  const [paxOptions, setPaxOptions] = useState([]);

  useEffect(() => {
    setInit(init);
    setAirportOptions(getAirportsOptions(departures));
  }, []);

  /* Update parent form on every child input change */
  useEffect(() => {
    updateInput(name, inputs);
  }, [inputs]);

  useEffect(() => {
    updateValidity(name, isValid);
  }, [isValid]);

  /* Update date options and reset inputs when airport is selected */
  useEffect(() => {
    setDateOptions(getDateOptions(departures, inputs.departureAirport));
    updateMultiple({
      departureId: "",
      outbound: undefined,
      homebound: undefined,
      nrOfPax: undefined,
      pricing: undefined,
    });
    setPriceSettings({});
  }, [inputs.departureAirport]);

useEffect(() => {
  if (inputs.departureId) {
    const departure = getDepartureData(departures, inputs.departureId);
    if (!departure) {
      console.log("no departure found");
      return;
    }

    const { outbound, homebound, pricing, tag } = departure;
    updateMultiple({
      outbound,
      homebound,
      pricing,
      tag, 
      nrOfPax: undefined,
    });
    setPaxOptions(getPaxOptions(pricing));
    setPriceSettings(pricing);
  }
}, [inputs.departureId, departures]);


  useEffect(() => {
    if (inputs.nrOfPax && inputs.pricing) {
      setBasePrice(
        inputs.nrOfPax,
        inputs.pricing,
        addSpecification,
        removeSpecification
      );
    } else {
      removeSpecification({ type: "basic" }, true);
    }
  }, [inputs.nrOfPax]);

  return (
    <div className="form-section section-grid">
      <span className="first-grid-only">
        <Select
          name="departureAirport"
          label={uppercase(strings.departureAirport)}
          bold={true}
          value={inputs.departureAirport}
          error={errors.departureAirport}
          options={airportOptions}
          onChange={handleChange}
          placeholder={strings.departureAirportPlaceholder}
          displayError={displayErrors}
        />

        <Select
          name="departureId"
          label={uppercase(strings.departureDate)}
          bold={true}
          value={inputs.departureId}
          error={errors.departureId}
          options={dateOptions}
          onChange={handleChange}
          placeholder={strings.departureDatePlaceholder}
          displayError={displayErrors}
        />

        <Radio
          name="nrOfPax"
          label={uppercase(strings.nrOfPax)}
          value={inputs.nrOfPax}
          error={errors.nrOfPax}
          placeholder={strings.nrOfPaxPlaceholder}
          bold={true}
          onChange={handleChange}
          options={paxOptions}
          displayError={displayErrors}
        />
      </span>
    </div>
  );
};

export default Basic;
